import { render, staticRenderFns } from "./WhPhysicalCount.vue?vue&type=template&id=f47b0b26&scoped=true&"
import script from "./WhPhysicalCount.vue?vue&type=script&lang=js&"
export * from "./WhPhysicalCount.vue?vue&type=script&lang=js&"
import style0 from "./WhPhysicalCount.vue?vue&type=style&index=0&id=f47b0b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47b0b26",
  null
  
)

export default component.exports